import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IncomeExpensesListPage } from '../../../../income-expenses/income-expenses-list/income-expenses-list';
import * as moment from 'moment';

@Component({
    selector: 'page-home-imcome-expenses',
    templateUrl: 'home-imcome-expenses.html'
})


export class HomeImcomeExpensesPage {
    loader_totals = true;
    date_first: any;
    date_last: any;
    total_income = 0;
    total_expenses = 0;

    constructor(public globals: Globals,
        public navCtrl: NavController,
        public http: HttpClient) {
        this.date_first = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss");
        this.date_last = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss");
        this.getTotals();
    }

    async getTotals() {
        if (this.globals.public_key == '') {
            await this.globals.delay(3000);
        }
        this.getTotalsIncomeExpenses();
    }

    async getTotalsIncomeExpenses() {
        this.loader_totals = true;
        const params = new HttpParams()
            .set('public_key', this.globals.public_key)
            .set('datetime_init', this.date_first)
            .set('datetime_final', this.date_last);
        await this.http.post(this.globals.analytics_path + 'inexp/get_totals_income_expenses', params, {})
            .subscribe(async res => {
                this.total_income = res['total_income'];
                this.total_expenses = res['total_expenses'];
                this.loader_totals = false;
            }, err => {
                this.loader_totals = false;
            });
    }

    goToIncomeExpenses() {
        this.globals.side_menu_active = 'inexp';
        this.navCtrl.setRoot(IncomeExpensesListPage);
        this.globals.side_menu_active_analytics = false;
        this.globals.open_side_menu = false;
    }


}


// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-imcome-expenses/home-imcome-expenses.ts